import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': ['text-b1', 'text-b2', 'text-b3', 'text-sh1', 'text-sh3'],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}

export const parseNumericValue = (value: string): number => {
  const numericValue = Number(value);
  return isNaN(numericValue) ? 0 : numericValue;
};

// Formats a number to at most two decimals, removing trailing zeros and the decimal point if unnecessary
// (e.g., 1.40 → "1.4", 3.00 → "3").
export const formatNumber = (num: number): string => {
  if (isNaN(num)) return '';
  if (Number.isInteger(num)) return num.toString();
  return num.toFixed(2).replace(/\.?0+$/, '');
};

// Prevent non-integer input (no decimals, no 'e', no negative)
export const allowOnlyIntegers = (e: React.KeyboardEvent<HTMLInputElement>) => {
  const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

  if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
    e.preventDefault();
  }
};

export const formatHours = (hours: number, withHourText: boolean = true, decimal: number = 1) => {
  const rounded = parseFloat((hours ?? 0).toFixed(decimal)) || 0;
  if (withHourText) {
    return `${rounded} ${isPlurals(rounded) ? 'hours' : 'hour'}`;
  }
  return rounded;
};

export const getHoursFromPercent = (allocationPercentage: number, availableHours: number) => {
  return (allocationPercentage / 100) * availableHours;
};

export const isPlurals = (value: number) => value > 0 || value < 0;

export const generateFilterOptions = (options: any[], type?: string) => {
  if (!options) return [];
  const mappedOptions = options.map((option: any) => {
    return {
      value: parseInt(option.id),
      label: option.name,
    };
  });

  if (type === 'withAll') {
    return [
      {
        value: -1,
        label: 'All',
      },
      ...mappedOptions,
    ];
  }
  return mappedOptions;
};
